import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import Card from "components/Card";
import Text from "components/Text";
import styles from "./../../NewEmploymentContract.module.scss";
import "./MultiStep.scss";
import ToggleSwitch from "components/ToggleSwitch";
import Editor from "react-pell";
import colorPicker from "./../../../../../assets/images/color-picker.svg";
import CustomEditorForContract from "../CustomEditor";
import { useCommonPlaceholderAndEditorRefs } from "../customEditorUtils";

function StepFive({
  contractData,
  contractFormDisplayData,
  setFormDetails,
  handleSwitch,
  t,
}) {
  const designationType = localStorage.getItem("designation")
    ? +localStorage.getItem("designation")
    : 2;
  const {
    placeholderDropdownOpen,
    setPlaceholderDropdownOpen,
    editorContainerRefs,
    editorContentRefs,
  } = useCommonPlaceholderAndEditorRefs();
  let countFields = useMemo(() => {
    if (contractData) {
      return contractFormDisplayData.reduce((prev, curr) => {
        if (
          (curr.stepNumber === 1 ||
            curr.stepNumber === 2 ||
            curr.stepNumber === 3 ||
            curr.stepNumber === 4) &&
          curr.isMainSection
        ) {
          prev += 1;
        }
        return prev;
      }, 0);
    }
    return 0;
  }, [contractFormDisplayData, contractData]);
  const contractFields = useMemo(
    () =>
      contractFormDisplayData.map(
        (data, key) =>
          data.isHtmlContent &&
          data.stepNumber == 5 &&
          (data.inputType == null || data.inputType == 4) && (
            <Card
              radius="10px"
              marginBottom="10px"
              padding="30px"
              shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
              className={"pb-1 " + styles["card-container"]}
              key={key}
            >
              <div className="d-flex justify-content-between">
                <Text size="16px" secondary weight="600" marginBottom="20px">
                  {++countFields}. {data.title}
                </Text>
                <ToggleSwitch
                  label={data.title}
                  onChange={(e) => {
                    handleSwitch(key, e.currentTarget.checked);
                  }}
                  value={data.isActive}
                />
              </div>
              <div style={{ display: data.isActive ? "block" : "none" }}>
                <CustomEditorForContract
                  data={data}
                  editorContentRefs={editorContentRefs}
                  editorContainerRefs={editorContainerRefs}
                  uniqueKey={data.id}
                  index={key}
                  placeholderDropdownOpen={placeholderDropdownOpen}
                  setPlaceholderDropdownOpen={setPlaceholderDropdownOpen}
                  setFormDetails={setFormDetails}
                  contractData={contractData}
                />
              </div>
            </Card>
          )
      ),
    [contractFormDisplayData, countFields, placeholderDropdownOpen]
  );
  return (
    <div className={styles["step-form-wrapper"]}>
      {designationType === 2 && (
        <div className="new_contract_step1_associate_CF">
          <div className="Rectangle"></div>
          <span className="Job-Title">
            {t("contracts.theAssociateAgreeContd")}
          </span>
        </div>
      )}
      {contractFields}
    </div>
  );
}
export default withTranslation()(StepFive);
